import { formatBytes, travelDateLocalized } from '@/utils/travels'
import { FileTimelineEntry } from '@/models/serverRequests/FileTimelineEntry'
import { ClientFileInnerType } from '@/enum'

export const isFileViewable = (filename) => {
  // video
  if (filename.includes('.mp4')) {
    return false
  }

  // archive
  if (filename.includes('.zip') || filename.includes('.7z') || filename.includes('.rar')) {
    return false
  }

  return true
}

export class ServerFile {
  constructor ({
    id = 0,
    userId = 0,
    status = '',
    fileTimestamp = 0,
    fileType = '',
    fileName = '',
    fileSize = 0,
    fileInnerType = null,
    history = []
  } = {}) {
    this.id = id
    this.userId = userId
    this.status = status
    this.fileType = fileType
    this.fileTimestamp = new Date(fileTimestamp)
    this.fileName = fileName
    this.fileSize = fileSize
    this.fileInnerType = fileInnerType
    this.history = history.map(item => new FileTimelineEntry(item))
  }

  get formattedFileTimestamp () {
    return travelDateLocalized(this.fileTimestamp)
  }

  get formattedFileSize () {
    return formatBytes(this.fileSize)
  }

  get isFileViewable () {
    return isFileViewable(this.fileName)
  }
}
